import { Table, TableColumn } from '@servicetitan/design-system';
import { useOutboundCallerIdTableContext } from '../context';
import styles from './OutboundCallerIdTable.module.css';
import { OutboundCallerIdTableFilters } from './OutboundCallerIdTableFilters';
import { CampaignCell } from './CampaignCell';
import { PhoneCell } from './PhoneCell';
import { NameCell } from './NameCell';
import classNames from 'classnames';
import PageError from '../../PageError/PageError';
import { NumberRadioButtonCell } from '../NumberRadioButtonCell';

export const OutboundCallerIdTable = () => {
  const { table, loading, error, refetch } = useOutboundCallerIdTableContext();
  const { data, totalCount, page, onPageChange, onSelectionChange } = table;

  return (
    <div className={styles.tableContainer}>
      <PageError
        title={`General error: ${error}`}
        onRetry={refetch}
        show={!!error}
        className={styles.error}
      />
      <OutboundCallerIdTableFilters />
      <Table
        data={data}
        pageable={{}}
        loading={loading}
        skip={page.skip}
        total={totalCount ?? 0}
        pageSize={page.take}
        onPageChange={onPageChange}
        onSelectionChange={onSelectionChange}
        onRowClick={onSelectionChange}
        striped={false}
        resizable
        selectedField='selected'
        selectable={{
          enabled: true,
          mode: 'single',
        }}
        className={classNames(styles.table, {
          'skeleton-auto': loading,
        })}
      >
        <TableColumn
          width={40}
          cell={(props) =>
            NumberRadioButtonCell({
              checked: props.dataItem.selected,
              id: props.dataItem.id,
              onClick: () => {
                onSelectionChange({
                  dataItem: {
                    ...props.dataItem,
                    selected: true,
                  },
                });
              },
            })
          }
        />
        <TableColumn
          title='Phone'
          field='number'
          sortable={false}
          cell={PhoneCell}
          width={130}
        />
        <TableColumn
          title='Name'
          field='name'
          sortable={false}
          cell={NameCell}
        />
        <TableColumn
          title='Campaign'
          field='campaignName'
          sortable={false}
          cell={CampaignCell}
          width={130}
        />
      </Table>
    </div>
  );
};
